module.exports = __webpack_public_path__ + "static/img/6.33ef667.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/4/6.png
// module id = 86DN
// module chunks = 2